export default {
  selectedDataItem: null,

  draggingMode: false,
  draggingElement: null,

  mouseOverDataList: null,
  mouseOverDataElement: null

  // mouseOverDataItem: {val: {}} // {val: {}} чтобы не проверять по коду mouseOverDataItem на null
}



// WEBPACK FOOTER //
// ./src/technical/components/Treeview/draggTreeviewCommonDataBus.js